import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'underline', 'Underline', [["path",{"d":"M7 5v5a5 5 0 0 0 10 0v-5"}],["path",{"d":"M5 19h14"}]]);